import { Component, EventEmitter, Output } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-tarca-add-dialog',
  templateUrl: './tarca-add-dialog.component.html',
  styleUrls: ['./tarca-add-dialog.component.scss']
})
export class TarcaAddDialogComponent {
  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  target_type: string = 'air rifle';
  S10: number | null = null;
  S20: number | null = null;
  S30: number | null = null;
  S40: number | null = null;
  S50: number | null = null;
  S60: number | null = null;
  inner_center: number = 0;

  isSaving = false;

  readonly targetTypeOptions = [
    { value: 'air rifle', label: 'Zračna puška' },
    { value: 'pistol', label: 'Pištola' },
    { value: 'pistol decimal', label: 'Air pistol 40 dec' },
    { value: 'air serial', label: 'Zračna serijska puška' }
  ];

  constructor(private http: HttpClient) {}

  onSave() {
    if (this.isSaving) return;
    if (!this.target_type) {
      alert('Izberite vrsto tarče.');
      return;
    }

    const payload: any = {
      target_type: this.target_type,
      inner_center: this.inner_center
    };

    if (this.S10 !== null) payload.S10 = this.S10;
    if (this.S20 !== null) payload.S20 = this.S20;
    if (this.S30 !== null) payload.S30 = this.S30;
    if (this.S40 !== null) payload.S40 = this.S40;
    if (this.S50 !== null) payload.S50 = this.S50;
    if (this.S60 !== null) payload.S60 = this.S60;

    this.isSaving = true;
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    this.http.post('https://testapi.ovh/api/strelstvo/targets/manual', payload, { headers, params }).subscribe(
      (resp) => {
        this.isSaving = false;
        this.save.emit(resp);
      },
      (err) => {
        this.isSaving = false;
        console.error('Error creating manual target:', err);
        alert('Napaka pri dodajanju tarče!');
      }
    );
  }

  onCancel() {
    if (this.isSaving) return;
    this.cancel.emit();
  }
}
